var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-modal",
    {
      attrs: {
        "content-classes": _vm.computedContentClasses,
        "content-css": _vm.contentCss
      },
      on: {
        show: _vm.handleShow,
        hide: function($event) {
          _vm.$emit("hide")
        },
        "escape-key": function($event) {
          _vm.$emit("escape-key")
        }
      },
      model: {
        value: _vm.modalOpened,
        callback: function($$v) {
          _vm.modalOpened = $$v
        },
        expression: "modalOpened"
      }
    },
    [
      _c(
        "div",
        { staticClass: "modal-header" },
        [
          _c(
            "q-toolbar",
            { attrs: { color: "white", "text-color": "grey-9" } },
            [
              _c("q-toolbar-title", [_vm._v(_vm._s(_vm.title))]),
              _c(
                "q-btn",
                {
                  attrs: { flat: "", dense: "" },
                  on: {
                    click: function($event) {
                      _vm.modalOpened = false
                    }
                  }
                },
                [_c("q-icon", { attrs: { name: "close", color: "grey-5" } })],
                1
              )
            ],
            1
          ),
          _vm._t("header")
        ],
        2
      ),
      _c(
        "div",
        {
          staticClass: "modal-body big-modal-scroll col scroll",
          class: _vm.bodyClasses
        },
        [_vm._t("content")],
        2
      ),
      _vm.successHandler || _vm.$slots.footer
        ? _c(
            "div",
            { staticClass: "modal-footer" },
            [
              _vm._t("footer", [
                _c(
                  "q-btn",
                  {
                    attrs: { color: "positive" },
                    on: { click: _vm.successHandler }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.actionLabel ? _vm.actionLabel : _vm.$t("save")
                        ) +
                        "\n      "
                    )
                  ]
                )
              ])
            ],
            2
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }